<div class="container my-5">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">Configurações</li>
    </ol>
  </nav>

  <div *ngIf="isSaving" class="backdrop">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Salvando as Informações...</span>
    </div>
  </div>

  <h1 class="mb-4">Configurações do Perfil</h1>

  <div class="row">
    <div class="col-md-8">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="settingsForm" (ngSubmit)="onSubmit()">
            <!-- Foto do Perfil -->
            <div class="mb-4">
              <label class="form-label fw-bold">Foto do Perfil</label>
              <div class="d-flex align-items-center gap-4">
                <div class="photo-preview-container">
                  <img
                    *ngIf="imagePreview"
                    [src]="imagePreview"
                    alt="Foto do perfil"
                    class="profile-photo"
                  />
                  <div *ngIf="!imagePreview" class="profile-photo-placeholder">
                    <i class="fas fa-user fa-3x"></i>
                  </div>
                </div>
                <div class="flex-grow-1">
                  <input
                    type="file"
                    class="form-control"
                    id="photoInput"
                    accept="image/*"
                    (change)="onFileSelected($event)"
                  />
                  <div class="form-text">Formatos aceitos: JPG, PNG, GIF. Tamanho máximo: 5MB</div>
                  <button
                    *ngIf="imagePreview"
                    type="button"
                    class="btn btn-sm btn-outline-danger mt-2"
                    (click)="removePhoto()"
                  >
                    <i class="fas fa-trash me-1"></i>
                    Remover Foto
                  </button>
                </div>
              </div>
            </div>

            <hr />

            <!-- Nome -->
            <div class="mb-3">
              <label for="name" class="form-label fw-bold">Nome *</label>
              <input
                type="text"
                class="form-control"
                id="name"
                formControlName="name"
                placeholder="Digite seu nome"
                [ngClass]="{
                  'is-invalid': settingsForm.get('name')?.invalid && settingsForm.get('name')?.touched,
                  'is-valid': settingsForm.get('name')?.valid && settingsForm.get('name')?.touched
                }"
              />
              <div
                *ngIf="settingsForm.get('name')?.invalid && settingsForm.get('name')?.touched"
                class="invalid-feedback"
              >
                O nome é obrigatório.
              </div>
            </div>

            <!-- Email -->
            <div class="mb-3">
              <label for="email" class="form-label fw-bold">Email *</label>
              <input
                type="email"
                class="form-control"
                id="email"
                formControlName="email"
                placeholder="Digite seu email"
                [ngClass]="{
                  'is-invalid': settingsForm.get('email')?.invalid && settingsForm.get('email')?.touched,
                  'is-valid': settingsForm.get('email')?.valid && settingsForm.get('email')?.touched
                }"
              />
              <div
                *ngIf="settingsForm.get('email')?.invalid && settingsForm.get('email')?.touched"
                class="invalid-feedback"
              >
                <span *ngIf="settingsForm.get('email')?.errors?.['required']">O email é obrigatório.</span>
                <span *ngIf="settingsForm.get('email')?.errors?.['email']">Email inválido.</span>
              </div>
            </div>

            <hr />

            <!-- Alterar Senha (Opcional) -->
            <h5 class="mb-3">Alterar Senha (Opcional)</h5>
            <p class="text-muted small mb-4">
              Deixe em branco se não deseja alterar a senha.
            </p>

            <!-- Senha Atual -->
            <div class="mb-3">
              <label for="currentPassword" class="form-label">Senha Atual</label>
              <div class="input-group">
                <input
                  [type]="isCurrentPasswordVisible ? 'text' : 'password'"
                  class="form-control"
                  id="currentPassword"
                  formControlName="currentPassword"
                  placeholder="Digite sua senha atual"
                />
                <span class="input-group-text" style="cursor: pointer" (click)="toggleCurrentPasswordVisibility()">
                  <i [class]="isCurrentPasswordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                </span>
              </div>
            </div>

            <!-- Nova Senha -->
            <div class="mb-3">
              <label for="newPassword" class="form-label">Nova Senha</label>
              <div class="input-group">
                <input
                  [type]="isNewPasswordVisible ? 'text' : 'password'"
                  class="form-control"
                  id="newPassword"
                  formControlName="newPassword"
                  placeholder="Digite a nova senha"
                  [ngClass]="{
                    'is-invalid': settingsForm.get('newPassword')?.invalid && settingsForm.get('newPassword')?.touched && settingsForm.get('newPassword')?.value,
                    'is-valid': settingsForm.get('newPassword')?.valid && settingsForm.get('newPassword')?.touched && settingsForm.get('newPassword')?.value
                  }"
                />
                <span class="input-group-text" style="cursor: pointer" (click)="toggleNewPasswordVisibility()">
                  <i [class]="isNewPasswordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                </span>
              </div>
              <div
                *ngIf="settingsForm.get('newPassword')?.invalid && settingsForm.get('newPassword')?.touched && settingsForm.get('newPassword')?.value"
                class="invalid-feedback"
              >
                A senha deve ter no mínimo 3 caracteres.
              </div>
            </div>

            <!-- Confirmar Nova Senha -->
            <div class="mb-4">
              <label for="confirmPassword" class="form-label">Confirmar Nova Senha</label>
              <div class="input-group">
                <input
                  [type]="isConfirmPasswordVisible ? 'text' : 'password'"
                  class="form-control"
                  id="confirmPassword"
                  formControlName="confirmPassword"
                  placeholder="Repita a nova senha"
                  [ngClass]="{
                    'is-invalid': settingsForm.get('confirmPassword')?.invalid && settingsForm.get('confirmPassword')?.touched && settingsForm.get('confirmPassword')?.value,
                    'is-valid': settingsForm.get('confirmPassword')?.valid && settingsForm.get('confirmPassword')?.touched && settingsForm.get('confirmPassword')?.value
                  }"
                />
                <span class="input-group-text" style="cursor: pointer" (click)="toggleConfirmPasswordVisibility()">
                  <i [class]="isConfirmPasswordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                </span>
              </div>
              <div
                *ngIf="settingsForm.get('confirmPassword')?.invalid && settingsForm.get('confirmPassword')?.touched && settingsForm.get('confirmPassword')?.value"
                class="invalid-feedback"
              >
                A senha deve ter no mínimo 3 caracteres.
              </div>
            </div>

            <!-- Botão Salvar -->
            <div class="d-grid gap-2">
              <button
                type="submit"
                class="btn btn-primary btn-lg"
                [disabled]="isSaving || settingsForm.invalid"
              >
                <i class="fas fa-save me-2"></i>
                <span *ngIf="!isSaving">Salvar Alterações</span>
                <span *ngIf="isSaving">Salvando...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

